import { Injectable } from '@angular/core';
import { ByaHttp } from 'app/services/bya-http';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { changePasswordUser } from '../models/change-password-user';
import { AuthService } from '../../../../@bya/auth/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService extends ByaHttp {

  constructor(
    private http: HttpClient,
    protected dialog: MatDialog,
	  private _appConfigService: AppConfigService,
	  private _authService: AuthService
  ) { 
	  super(dialog, _authService);
  }

  postChangePassword(request:changePasswordUser): Observable<changePasswordUserResponse> {
    return this.http.post<changePasswordUserResponse>(this._appConfigService.IdentityAdminUrl + '/api/User/ChangePassword', request)
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<changePasswordUserResponse>('Cambiar contraseña de usuario', null))
      );
  }
  
}

export class changePasswordUserResponse{
  public isValid:boolean;
  public mensaje:string;
}
